/**
 * 倒计时
 * @param seconds  1、vue3 ref值  2、vue2 数值
 */
import { typeofs } from "./typeofs";
export function countdown(seconds) {
  const isObject = typeofs(seconds) === "Object";
  const timer = setInterval(() => {
    if (isObject) {
      if (seconds.value > 0) {
        seconds.value--;
      } else {
        clearInterval(timer);
      }
    } else {
      if (seconds > 0) {
        seconds--;
      } else {
        clearInterval(timer);
      }
    }
  }, 1000);
}
